import { Component, inject, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { environment } from '../../../environments/environment';
import { FormBuilder, FormGroup } from '@angular/forms';
import { HelperService } from '../services/helper.service';
import { HttpService } from '../services/http.service';
import { ToastService } from '../services/toast.service';
import { WizardComponent } from '../quick-action/wizard/wizard.component';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';
import { ApiService } from '../../api.service';
import { Outcome } from '../../outcome/outcome.service';
import { AuthService } from '../../auth/auth.service';
import { catchError, map, Observable, of } from 'rxjs';

@Component({
  selector: 'app-quarterly-outcome',
  templateUrl: './quarterly-outcome.component.html',
  styleUrl: './quarterly-outcome.component.css',
})
export class QuarterlyOutcomeComponent implements OnInit {
  @Input() isWorkPackage: boolean = false;
  @Input() isAnnual: boolean = false
  @Output() notifyParent = new EventEmitter<string>();
  accountableUserData: any = {};
  notStarted = 0;
  ongoing = 0;
  completed = 0;
  delayed = 0;
  terminated = 0;
  visible: boolean = false;
  currentPage: number = 1;
  pageSize: number = 10;
  totalItems: number = 120;
  @Input() isLoading = false;
  httpService = inject(HttpService);
  helperService = inject(HelperService);
  toastService = inject(ToastService);
  auth = inject(AuthService);
  helper=inject(HelperService)

  @Input() isMytask: boolean = false;
  @Input() quarterlyOutcomesLists: any = [];
  outcomesData: any = {};
  workPkgLists: any = [];
  isOpenTerminateModal: boolean = false;
  terminateOutcomeData: any;
  outcomeId: any;
  // outcomeService: any;
  outcomeDetailData: any;
  detailOutcomeData: any;
  userData: any;
  workPackageSelectedData: any;
  tagWP(outcomeData: any) {
    this.outcomesData = outcomeData;
    this.accountableUserData = outcomeData?.user;
    this.visible = true;
  }
  workForm!: FormGroup;

  ref: DynamicDialogRef | undefined;
  annualOutcomeId: number = 0;
  cat: any;
  private apiService = inject(ApiService);
  private outcomeService = inject(Outcome);

  constructor(private fb: FormBuilder, public dialogService: DialogService) { }


  ngOnInit(): void {
    this.apiService.role$.subscribe((data) => {
      this.cat = data;
    });
    this.workForm = this.fb.group({
      outcome_id: [this.outcomesData?.outcome_id],
      type: [''],
      workpackage_id: [''],
    });
    this.annualOutcomeId = this.quarterlyOutcomesLists[0]['annual_outcome_id'];
    this.detailOutcome(this.cat);
    this.totalItems = this.quarterlyOutcomesLists?.length;

  }

  handleChildEvent(event:any) {
    this.notifyParent.emit();
  }

 detailOutcome(cat: any) {
    const payload = { outcome_id: this.annualOutcomeId };
    this.outcomeService.detailOutcome(payload, cat).subscribe(
      (data: any) => {

        try {
          const parsedData: any = data;
          this.detailOutcomeData = parsedData?.data;
        } catch (error) {
          console.error('Error parsing decoded data:', error);
        }
      },
      (error: any) => {
        console.error('Error fetching users', error);
      }
    );
  }

  onTypeChange(event: any) {
    this.workForm?.get('outcome_id')?.setValue(this.outcomesData?.outcome_id);
    this.workForm.get('type')?.setValue(event?.value?.label);
    if (this.workForm.get('type')?.value) {
      this.filterWorkPackages();
    }
  }

  onWorkPkgChange(event: any) {
    this.workPackageSelectedData=event?.value
    this.workForm.get('workpackage_id')?.setValue(event?.value?.package_id);
  }

  onWPSearchList(event: any) {
    this.filterWorkPackages(event.filter);
  }
  filterWorkPackages(search?: any) {
    const currentSelection = this.workPackageSelectedData
  
    this.httpService
      .post(`${environment.opbBackendHost}/api/member/workpackage/list`, {
        member_id: this.outcomesData?.user?.user_id,
        search: search,
      })
      .subscribe(
        (response: any) => {
          this.workPkgLists = response?.data || [];
          // Preserve selection if it still exists in the updated list
          if (currentSelection && !this.workPkgLists.find((item:any) => item.package_id == currentSelection.package_id)) {
            this.workPkgLists.push(currentSelection);
          }
        },
        (error: any) => {
          console.error('Error fetching outcomes:', error);
        }
      );
  }
  

  closeTaggedModal() {
    this.visible = false;
  }

  onSubmit(): void {
    this.httpService
      .post(`${environment.opbBackendHost}/api/member/quarterly/outcomes/tag`, {
        ...this.workForm.value,
      })
      .subscribe(
        (response: any) => {
          response?.error
            ? this.toastService.error(response?.message)
            : this.toastService.success(response?.message);

            if(!response?.error){
              this.notifyParent.emit()
            }
          this.closeTaggedModal();
          this.isLoading = false;
        },
        (error: any) => {
          this.isLoading = false;
        }
      );
  }

  openTerminateModal(outcome: any) {
    this.isOpenTerminateModal = true;
    this.terminateOutcomeData = outcome;
  }

  closeTerminateModal() {
    this.isOpenTerminateModal = false;
  }

  terminateOutcome() {
    this.httpService
      .post(
        `${environment.opbBackendHost}/api/member/quarterly/outcomes/terminate`,
        {
          outcome_id: this.terminateOutcomeData?.outcome_id,
        }
      )
      .subscribe((res: any) => {
        if (res) {
          res?.error
            ? this.toastService.error(res?.message)
            : this.toastService.success(res?.message);
          if (!res?.error) {
            this.notifyParent.emit();
          }
          this.closeTerminateModal();
        }
      });
  }

  addMileStone(data?: any) {
    this.httpService
      .post(`${environment.opbBackendHost}/api/member/milestones/update`, {
        ...data,
      })
      .subscribe((res: any) => {
        this.toastService.error(res?.message);
      });
  }

  TypesOfWork: any = [
    { key: 'foundational-work', label: 'Foundational Work' },
    { key: 'ad-hoc', label: 'Ad-hoc' },
    { key: 'work-package', label: 'Work Package' },
    { key: 'untagged', label: 'Untagged' },
  ];

  getDefaultAvatar() {
    return this.helperService.defaultImageUrl;
  }

  loadOutcomes(page: number = 1): void {
    this.isLoading = true;
    this.httpService
      .post(`${environment.opbBackendHost}/api/member/my/tasks`, { page })
      .subscribe(
        (response: any) => {
          this.quarterlyOutcomesLists = response.data || [];
          this.totalItems = response.data?.length || 0;
          this.isLoading = false;
        },
        (error: any) => {
          console.error('Error fetching outcomes:', error);
          this.isLoading = false;
        }
      );
  }

  // openWizard(list:any) {
  //   this.annualOutcomeId=list?.annual_outcome_id
  //   this.detailOutcome(this.cat);
  //   setTimeout(() => {

  //     this.ref = this.dialogService.open(WizardComponent, {
  //       width: '90%',
  //       contentStyle: { 'max-height': '90vh', overflow: 'auto' },
  //       baseZIndex: 10000,
  //       data: {
  //         // Pass the custom data here
  //         selectedSTOId:list?.outcome_id || null,
  //         annualOutcomeId:list?.annual_outcome_id,
  //         detailOutcomeData: this.detailOutcomeData,
  //         step: 2,
  //       },
  //     });

  //     this.ref.onClose.subscribe(() => {
  //       this.helper.isOutcomeDataLoad$.next(true)
  //   });
  //   }, 0);

    
  // }

  openWizard(list: any) {
    this.annualOutcomeId = list?.annual_outcome_id;
  
    this.loadDetailOutcome(this.cat).subscribe((data: any) => {
      if (data) {
        this.detailOutcomeData = data; 
      }

      this.ref = this.dialogService.open(WizardComponent, {
        width: '90%',
        contentStyle: { 'max-height': '90vh', overflow: 'auto' },
        baseZIndex: 10000,
        data: {
          selectedSTOId: list?.outcome_id || null,
          annualOutcomeId: list?.annual_outcome_id,
          detailOutcomeData: this.detailOutcomeData,
          step: 2,
        },
      });
  
      this.ref.onClose.subscribe(() => {
        this.helper.isOutcomeDataLoad$.next(true);
      });
    });
  }
  

  loadDetailOutcome(cat: any): Observable<any> {
    const payload = { outcome_id: this.annualOutcomeId };
    return this.outcomeService.detailOutcome(payload, cat).pipe(
      map((data: any) => data?.data), 
      catchError((error: any) => {
        console.error('Error fetching details:', error);
        return of(null); 
      })
    );
  }
  
}


